import * as React from 'react';
const CartilagineDelGinocchioConsumataIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px;stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M82.24 60.04c8.76 3.79 45.53 27.5 52.59 34.6 7.07 7.09-5.41 40.7-5.41 45.33M63 100.06s21.28 13.63 29.23 16.22c0 0-3.7 12.21-3.7 23.68"
      className="prefix__cls-2"
    />
    <path
      d="M76.32 64.48c18.97 24.05 39.41 23.68 43.66 29.6s-4.24 17.21-12.11 16.65-.29-2.41-11.02-10.73c-10.73-8.33-22.48-18.96-33.86-22.2M119.62 112.58c7.22 9.25-2.13 13.72-2.13 18.78v8.6M101.6 114.43c-3.29 7.03 4.13 6.66-.12 25.53"
      className="prefix__cls-2"
    />
    <path
      d="M104.81 117.02c1.48 3.33 5.74 1.11 8.33 2.04s5.98 3.05 9.22 1.82"
      className="prefix__cls-2"
    />
    <path
      d="M128 98.52s7.87 9.63-1.57 17.76c0 0-7.14-7.69 1.57-17.76"
      style={{
        stroke: secondaryColor || '#ffcf38',
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
      }}
    />
  </svg>
);
export default CartilagineDelGinocchioConsumataIcon;
